// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__zMQkC","content":"Tooltip_content__ABxoO","arrow":"Tooltip_arrow__WI8OZ","span":"Tooltip_span__4YBX2","fade_in":"Tooltip_fade_in__A6s7Q"};